// extracted by mini-css-extract-plugin
export default {"tagList":"problemTypeSpiderChart_tagList__jo2GJ"};